
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Tabs, Tag, Flex, Card, Col, Row, theme, Tooltip } from 'antd';

import QuotationsTable from 'Pages/HomePage/QuotationsTable';
import Filters from 'Pages/HomePage/Filters';
import { InsuranceCarrierLogo } from 'Components/commonComponents/InsuranceCarrierLogo';
import { ChosenByClientBadge } from '@shared/components/ChosenByClientBadge';
import { TabLabel } from 'Components/TabLabel';
import { useGetQuotations } from '@features/quotations/hooks/useQuotations';

import {
  getQuotationsSlopes,
  setConfigurationQuotationsSlopes,

  getQuotationsSlopesToEmit,
  setConfigurationQuotationsSlopesToEmit,

  getQuotationsEmitted,
  setConfigurationQuotationsEmitted,
} from 'Redux/actions/tableQuotations';
import fetchSoftsegurosVendedores from 'Redux/actions/softsegurosVendedoresActions';
import { formatDateForDisplay } from '@shared/utils/dateUtils';

const HomePage = ({
  getQuotationsSlopesProps,
  setConfigurationQuotationsSlopesProps,

  getQuotationsEmittedProps,
  setConfigurationQuotationsEmittedProps,

  getQuotationsSlopesToEmitProps,
  setConfigurationQuotationsSlopesToEmitProps,

  aseguradorasState = [],

  quotationsSlopesState = {},
  quotationsSlopesToEmitState = {},
  quotationsEmittedState = {},

  fetchSoftsegurosVendedoresProps,
  userPerfilId,
  marcaBlanca,
  storedAppliedFilters,
  userAccess,
}) => {
  const [currentPagePending, setCurrentPagePending] = useState(1);
  
  const { token: themeToken } = theme.useToken();

  const pendingQuotationsQuery = useGetQuotations({ state: 'PENDING', page: currentPagePending, ...storedAppliedFilters });

  useEffect(() => {
    // TODO: mover esta consulta a un lugar más adecuado. Ya no se filtra por vendedores, pero se deja porque los resultados se guardan en el store y se usan al crear pólizas y solicitudes
    fetchSoftsegurosVendedoresProps();
  }, []);

  const getInsuranceCarriersLogos = (packagesDataSelected) => (
    // <Flex align='center' justify='center' gap='small' wrap>
    //   {packagesDataSelected.map((packageDataSelected) => {
    //     const insuranceCarrier = aseguradorasState.find((aseguradora) => aseguradora.id === packageDataSelected.insurance_carrier);
    //     return (
    //       <Card key={packageDataSelected.id} style={{ backgroundColor: packageDataSelected.client_preference ? '#cde9ff' : '#fff', width: 'fit-content' }} styles={{ body: { padding: 4 } }}>
    //         <img
    //           src={insuranceCarrier.logo_url}
    //           alt={insuranceCarrier.name}
    //           style={{ width: '70px' }}
    //           title={packageDataSelected.package_detail}
    //           data-id={packageDataSelected.id}
    //         />
    //       </Card>
    //     );
    //   })}
    // </Flex>
    <Row gutter={[12, 12]} justify='center'>
      {packagesDataSelected.map(({ id, insurance_carrier: insuranceCarrierId, package_detail: planName, client_preference: isChosenByClient }) => {
        const { name, logo_url: logoUrl } = aseguradorasState.find((insuranceCarrier) => insuranceCarrier.id === insuranceCarrierId) ?? {};
        return (
          <Col key={id} flex={'0 0 6em'}>
            <ChosenByClientBadge isChosenByClient={isChosenByClient} size='small'>
              <Tooltip title={planName}>
                <Card
                  style={{
                    ...(isChosenByClient && { borderColor: themeToken.colorPrimary }),
                  }}
                  styles={{
                    body: {
                      padding: 8,
                      height: '100%',
                      display: 'grid',
                      placeContent: 'center',
                    },
                  }}
                >
                  <InsuranceCarrierLogo name={name} logoUrl={logoUrl} disableTooltip />
                </Card>
              </Tooltip>
            </ChosenByClientBadge>
          </Col>
        );
      })}
    </Row>
  );

  const serializeQuotations = (tableType, quotations = []) => quotations.map((quotationData) => {
    // Evaluar si el cliente YA marcó alguna cotización desde el link del email
    const someQuotationSelected = quotationData.packages_data_selected.find((quotationPackage) => quotationPackage.client_preference);
    const vehicleIsNewBadge = quotationData.vehicle_data.is_new && (
      <Tag color='blue' style={{ margin: 0 }}>
        Nuevo
      </Tag>
    );
    return {
      ...quotationData,

      key: quotationData.id,
      showNumber: someQuotationSelected ? (
        <span
          title={`El cliente seleccionó un paquete de esta cotización: ${someQuotationSelected.package_detail}`}
          style={{
            background: marcaBlanca?.color_marca_blanca_resaltado,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

          }}
        >
          {quotationData.number}
        </span>
      ) : quotationData.number,

      // campos serializados
      placa: (
        <Flex align='center' justify='center' vertical>
          <span>{quotationData.vehicle_data.placa || 'Sin placa'}</span>
          {vehicleIsNewBadge}
        </Flex>
      ),
      vehicleModel: `${quotationData.vehicle_data.marca || '-'} / ${quotationData.vehicle_data.modelo || '-'}`,
      vendedor: quotationData.created_by_data.softseguros_vendedor_nombre,
      logosAseguradorasPackages: getInsuranceCarriersLogos(quotationData.packages_data_selected),
      createdBy: quotationData.created_by_data.full_name || quotationData.created_by_data.username,
      createdAtFormated: formatDateForDisplay(quotationData.created_at),
      updatedAt: formatDateForDisplay(quotationData.updated_at),
      solicitud_expedicion_date_formated: formatDateForDisplay(quotationData.solicitud_expedicion_date),
      solicitud_expedicion_package_detail: quotationData.solicitud_expedicion_package && getInsuranceCarriersLogos([quotationData.solicitud_expedicion_package]),
      clientDetail: quotationData.client_data && (
        <div>
          <span>{quotationData.client_data.document_number}</span>
          <br />
          <span>{quotationData.client_data.full_name}</span>
        </div>
      ),
      softseguros_police_created_at_detail: formatDateForDisplay(quotationData.softseguros_police_created_at),
    };
  });

  // Acción que consulta las cotizaciones Pendientes desde el servidor
  const filterQuotationsSlopes = ({ page }) => {
    // Guardar globalmente como estado la página
    setConfigurationQuotationsSlopesProps({ page });

    // Consultar todas las cotizaciones
    getQuotationsSlopesProps({ state: 'DONE' });
  };

  const filterQuotationsSlopesToEmit = ({ page }) => {
    // Guardar globalmente como estado la página
    setConfigurationQuotationsSlopesToEmitProps({ page });

    // Consultar todas las cotizaciones
    getQuotationsSlopesToEmitProps({ state: 'SLOPE_EMIT' });
  };

  const filterQuotationsEmitted = ({ page }) => {
    // Guardar globalmente como estado la página
    setConfigurationQuotationsEmittedProps({ page });

    // Consultar todas las cotizaciones
    getQuotationsEmittedProps({ state: 'EMITTED' });
  };

  const filterAllTabs = () => {
    setCurrentPagePending(1);
    filterQuotationsSlopes({ page: 1 });
    filterQuotationsSlopesToEmit({ page: 1 });
    filterQuotationsEmitted({ page: 1 });
  };

  return (
    <Card
      title={<Filters onChange={filterAllTabs} />}
      style={{ width: '100%' }}
      styles={{
        title: {
          overflow: 'visible', // Evita que el Badge del botón 'Filtros' se recorte dentro del header
        },
      }}
    >
      <Tabs
        items={[
          userAccess.usuarios?.features.tokens_externos_multicotizador && { // Solo se muestra esta pestaña si el usuario tiene habilitado la funcionalidad de crear tokens externos para el cotizador de autos
            key: 'PENDING',
            label: <TabLabel title='Pendientes por cotizar' count={pendingQuotationsQuery.data?.count} loading={pendingQuotationsQuery.isFetching} />,
            children: (
              <QuotationsTable
                tableType='PENDING'
                getPage={(page) => setCurrentPagePending(page)}
                loading={pendingQuotationsQuery.isFetching}
                items={serializeQuotations('PENDING', pendingQuotationsQuery.data?.results)}
                page={pendingQuotationsQuery.data?.page}
                pageSize={10}
                totalItems={pendingQuotationsQuery.data?.count}
                resetResultsAllTabs={filterAllTabs}
              />
            ),
          },
          {
            key: 'DONE',
            label: <TabLabel title='Cotizaciones' count={quotationsSlopesState.requestState.statusCode ? quotationsSlopesState.total_records : null} loading={quotationsSlopesState.requestState.isFetching} />,
            children: (
              <QuotationsTable
                tableType='DONE'
                getPage={(page) => filterQuotationsSlopes({ page })}
                loading={quotationsSlopesState.requestState.isFetching}
                items={serializeQuotations('DONE', quotationsSlopesState.results)}
                page={quotationsSlopesState.page}
                pageSize={quotationsSlopesState.page_size}
                totalItems={quotationsSlopesState.total_records}
                resetResultsAllTabs={filterAllTabs}
              />
            ),
          },
          {
            key: 'SLOPE_EMIT',
            label: <TabLabel title='Pendientes por emitir' count={quotationsSlopesToEmitState.requestState.statusCode ? quotationsSlopesToEmitState.total_records : null} loading={quotationsSlopesToEmitState.requestState.isFetching} />,
            children: (
              <QuotationsTable
                tableType='SLOPE_EMIT'
                getPage={(page) => filterQuotationsSlopesToEmit({ page })}
                loading={quotationsSlopesToEmitState.requestState.isFetching}
                items={serializeQuotations('SLOPE_EMIT', quotationsSlopesToEmitState.results)}
                page={quotationsSlopesToEmitState.page}
                pageSize={quotationsSlopesToEmitState.page_size}
                totalItems={quotationsSlopesToEmitState.total_records}
                resetResultsAllTabs={filterAllTabs}
              />
            ),
          },
          {
            key: 'EMITTED',
            label: <TabLabel title='Emitidas' count={quotationsEmittedState.requestState.statusCode ? quotationsEmittedState.total_records : null} loading={quotationsEmittedState.requestState.isFetching} />,
            children: (
              <QuotationsTable
                tableType='EMITTED'
                getPage={(page) => filterQuotationsEmitted({ page })}
                loading={quotationsEmittedState.requestState.isFetching}
                items={serializeQuotations('EMITTED', quotationsEmittedState.results)}
                page={quotationsEmittedState.page}
                pageSize={quotationsEmittedState.page_size}
                totalItems={quotationsEmittedState.total_records}
                resetResultsAllTabs={filterAllTabs}
              />
            ),
          }
        ].filter(Boolean)}
      />
    </Card>
  );
};

const quotationPropTypes = PropTypes.shape({
  requestState: PropTypes.shape({
    isFetching: PropTypes.bool,
  }),
  results: PropTypes.any,
  page: PropTypes.any,
  page_size: PropTypes.any,
  total_records: PropTypes.any,
});

HomePage.propTypes = {
  getQuotationsSlopesProps: PropTypes.func,
  setConfigurationQuotationsSlopesProps: PropTypes.func,

  getQuotationsEmittedProps: PropTypes.func,
  setConfigurationQuotationsEmittedProps: PropTypes.func,

  getQuotationsSlopesToEmitProps: PropTypes.func,
  setConfigurationQuotationsSlopesToEmitProps: PropTypes.func,

  aseguradorasState: PropTypes.any,

  quotationsSlopesState: quotationPropTypes,
  quotationsSlopesToEmitState: quotationPropTypes,
  quotationsEmittedState: quotationPropTypes,

  fetchSoftsegurosVendedoresProps: PropTypes.func.isRequired,
  userPerfilId: PropTypes.number.isRequired,
};

// Conexión al store (pendiente por modificar)
const mapStateToProps = (state) => ({
  aseguradorasState: state.initialData.aseguradoras,

  quotationsSlopesState: state.tableQuotations.quotationsSlopes,
  quotationsSlopesToEmitState: state.tableQuotations.quotationsSlopesToEmit,
  quotationsEmittedState: state.tableQuotations.quotationsEmitted,
  userPerfilId: state.initialData.user.perfil,
  marcaBlanca: state.initialData.marcablanca,
  storedAppliedFilters: state.tableQuotations.filtersTableQuotations,
  userAccess: state.initialData.userAccess,
});

const actions = {
  getQuotationsSlopesProps: getQuotationsSlopes,
  setConfigurationQuotationsSlopesProps: setConfigurationQuotationsSlopes,
  getQuotationsEmittedProps: getQuotationsEmitted,
  setConfigurationQuotationsEmittedProps: setConfigurationQuotationsEmitted,
  getQuotationsSlopesToEmitProps: getQuotationsSlopesToEmit,
  setConfigurationQuotationsSlopesToEmitProps: setConfigurationQuotationsSlopesToEmit,
  fetchSoftsegurosVendedoresProps: fetchSoftsegurosVendedores,
};

export default connect(mapStateToProps, actions)(HomePage);
